(() => {
  'use strict';
  let headerObserver;
  const initialize = () => {
    const header = document.querySelector('.shopify-section:has(.site-header)');
    if (header && !header.dataset.sizeObserved) {
      header.dataset.sizeObserved = 'true';
      const measure = () => document.documentElement.style.setProperty('--store-header-height', header.getBoundingClientRect().height + 'px');
      headerObserver?.disconnect();
      measure(); if ('ResizeObserver' in window) { headerObserver = new ResizeObserver(measure); headerObserver.observe(header); }
    }
  };
  document.addEventListener('click', event => {
    const summary = event.target.closest('.atlas-ritual-step>summary');
    if (!summary || !matchMedia('(max-width:850px)').matches) return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (!summary.parentElement.open) return;
      const photo = summary.closest('.atlas-ritual').querySelector('.atlas-ritual-photo');
      const rect = photo.getBoundingClientRect();
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--store-header-height')) || 102;
      if (rect.top < headerHeight || rect.bottom > innerHeight - 76) photo.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }));
  });
  initialize(); document.addEventListener('shopify:section:load', initialize);
})();
